import { useSelector } from 'react-redux';

import { selectInspectListings } from '../selectors/inspectListings';

export const useInspectListings = (): boolean | undefined =>
  useSelector(selectInspectListings) || undefined;
